import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY, USER_SUCCESS_KEY} from "shared/const/localstorage";
import {userActions} from "entities/User/model/slice/userSlice";
import {fetchProfileData} from "entities/Profile/model/fetchProfileDate/fetchProfileDate";
import {accountUserActions} from "app/accountLoginSlice";
import {loginActions} from "../../slice/lodinSlice";
import OneSignal from "react-onesignal";
import {useNavigate} from "react-router-dom";

interface ILoginByUsernameProps {
    email: string;
    password: string;
}


export const loginByUsername = createAsyncThunk<void, ILoginByUsernameProps>(
    'login/loginByUsername',
    async (authData, thunkAPI) => {
        try {
            const response = await axios.post('/api/login', authData);
            if (response.data.success) {
                const userId = response.data.data.userId;
                OneSignal.login(userId)
                    .then(() => {
                        // console.log("Вход выполнен успешно");
                    })
                    .catch(error => {
                        console.error("Ошибка входа в OneSignal:", error);
                        console.log(error.message,'error.message')
                        console.log(error,'error')
                    });
                localStorage.setItem(USER_LOCALSTORAGE_KEY, JSON.stringify(response.data.data));
                localStorage.setItem(USER_SUCCESS_KEY, JSON.stringify(response.data.success));
                thunkAPI.dispatch(userActions.initAuthData(response.data.success));
                await thunkAPI.dispatch(fetchProfileData());

            }

            thunkAPI.dispatch(accountUserActions.accountUser(response.data));
            thunkAPI.dispatch(loginActions.setError(response.data));

        } catch (e) {
            console.error("Registration error:", e);
            throw e;
        }
    }
);
